import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Typography } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import Button from "../components/Button";

const { Title, Text } = Typography;

export default function PurchaseCancelled() {
  return (
    <CancelBg>
      <Content>
        <IconWrapper>
          <CloseCircleOutlined style={{ color: "#2C5F2D", fontSize: 48 }} />
        </IconWrapper>
        <CancelTitle level={1}>Purchase Cancelled</CancelTitle>
        <MessageText>
          Your purchase was not completed. This could be because:
        </MessageText>
        <ReasonsList>
          <ReasonItem>You cancelled the checkout process</ReasonItem>
          <ReasonItem>There was an issue with the payment</ReasonItem>
          <ReasonItem>The session expired</ReasonItem>
        </ReasonsList>
        <StyledText>
          Don't worry! You can try again or contact us if you need assistance.
        </StyledText>
        <ButtonGroup>
          <Link to="/#pricing">
            <PrimaryButton size="large" variant="primary">
              Try Again
            </PrimaryButton>
          </Link>
          <Link to="/contact">
            <SecondaryButton size="large" variant="text">
              Contact Support
            </SecondaryButton>
          </Link>
        </ButtonGroup>
      </Content>
    </CancelBg>
  );
}

const CancelBg = styled.div`
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(
    120deg,
    #181818 0%,
    #2c5f2d 40%,
    #4a7c59 75%,
    #e6f3e6 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  background: var(--color-bg-secondary, #fff);
  padding: 64px;
  border-radius: 20px;
  box-shadow:
    0 8px 32px rgba(44, 95, 45, 0.18),
    0 2px 24px rgba(24, 24, 24, 0.1);
  border: 2.5px solid #2c5f2d;
  @media (max-width: 767px) {
    max-width: 98vw;
    padding: 32px 8px;
  }
`;

const IconWrapper = styled.div`
  font-size: 64px;
  color: #2c5f2d;
  margin-bottom: 24px;
  svg {
    filter: drop-shadow(0 4px 8px rgba(44, 95, 45, 0.12));
  }
`;

const CancelTitle = styled(Title)`
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif !important;
  font-size: 2.2rem !important;
  font-weight: 700 !important;
  color: #2c5f2d !important;
  margin-bottom: 0.5rem !important;
  letter-spacing: -0.02em !important;
`;

const MessageText = styled(Text)`
  display: block;
  font-size: 1.08rem;
  margin-bottom: 24px;
  color: #666;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
`;

const StyledText = styled(Text)`
  color: #333;
  font-size: 1.08rem;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
`;

const ReasonsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 32px 0;
  text-align: left;
`;

const ReasonItem = styled.li`
  margin: 12px 0;
  color: #666;
  font-size: 1.08rem;
  position: relative;
  padding-left: 24px;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  &:before {
    content: "•";
    position: absolute;
    left: 8px;
    color: #2c5f2d;
    font-size: 1.2em;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 32px;
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const PrimaryButton = styled(Button)`
  background: linear-gradient(90deg, #2c5f2d 0%, #4a7c59 100%) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 12px !important;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif !important;
  font-weight: 700 !important;
  font-size: 1.08rem !important;
  padding: 0.9rem 2.2rem !important;
  box-shadow: 0 4px 16px rgba(44, 95, 45, 0.18) !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  &:hover {
    background: linear-gradient(90deg, #4a7c59 0%, #2c5f2d 100%) !important;
    color: #fff !important;
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 8px 32px rgba(44, 95, 45, 0.25) !important;
  }
`;

const SecondaryButton = styled(Button)`
  background: transparent !important;
  color: #2c5f2d !important;
  border: 2px solid #2c5f2d !important;
  border-radius: 12px !important;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif !important;
  font-weight: 600 !important;
  font-size: 1.08rem !important;
  padding: 0.9rem 2.2rem !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  &:hover {
    background: #2c5f2d !important;
    color: #fff !important;
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 8px 32px rgba(44, 95, 45, 0.25) !important;
  }
`;
